module.exports = __webpack_public_path__ + "img/file-bimistock------------------------------------------------------@1x.4e318da4.png";